import { ref } from 'vue';
import { defineStore } from 'pinia';

export interface PopupItem {
  viewName: string;
  popup: Window;
}

export const useBrowserPopupStore = defineStore('browserPopup', () => {
  const isAddedMsgEvent = ref(false);
  const popupList = ref<PopupItem[]>([]);

  const createPopup = (viewName: string, popupWindow: Window) => {
    // 사용자가 네이티브 X로 닫은 팝업은 popupList에 dead Window 참조로 남아 GC를 막는다.
    // 새 팝업 등록 시점에 닫힌 항목을 정리해 누적을 방지한다(모두 동일 오리진이라 .closed 접근이 안전).
    popupList.value = popupList.value.filter((item) => !item.popup.closed);

    popupList.value.push({
      viewName,
      popup: popupWindow,
    });
  };

  const closePopup = (viewName: string) => {
    const targetPopupIdx = popupList.value.findIndex((popup) => popup.viewName === viewName);

    if (targetPopupIdx > -1) {
      const targetPopupItem = popupList.value[targetPopupIdx];
      targetPopupItem.popup.close();
      popupList.value.splice(targetPopupIdx, 1);
    }
  };

  const addPopup = (isSingle: boolean, viewName: string, popupWindow: Window) => {
    if (isSingle) {
      closePopup(viewName);
    }
    createPopup(viewName, popupWindow);
  };

  const closeAllPopup = () => {
    popupList.value.forEach((item) => {
      item.popup.close();
    });
    popupList.value = [];
  };

  return {
    isAddedMsgEvent,
    popupList,
    addPopup,
    closeAllPopup,
  };
});
